module.exports = __webpack_public_path__ + "5061ddaaf90fdf1e76070da69047d325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Inspirations/inspiration.jpg
// module id = 1431
// module chunks = 38